var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomSuite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3C12.8699 3 13.2096 3.20418 13.3832 3.53084L16.7686 9.90342L20.8147 6.09533C21.1265 5.8018 21.5907 5.73946 21.969 5.9403C22.3473 6.14115 22.5556 6.56058 22.4872 6.98335L20.3539 20.1598C20.2754 20.6441 19.8573 21 19.3667 21H5.36671C4.86861 21 4.44646 20.6334 4.37659 20.1403L2.50993 6.9638C2.45036 6.54335 2.66284 6.13113 3.03985 5.93571C3.41686 5.74029 3.87618 5.80429 4.18541 6.09533L8.2315 9.90342L11.6169 3.53085C11.7905 3.20419 12.1301 3 12.5 3ZM12.5 6.13149L9.38317 11.9986C9.2369 12.2739 8.9706 12.4653 8.663 12.5161C8.3554 12.5669 8.04171 12.4713 7.81469 12.2576L4.88988 9.50486L6.23503 19H18.5156L20.0426 9.5685L17.1854 12.2576C16.9584 12.4713 16.6447 12.5669 16.3371 12.5161C16.0295 12.4653 15.7632 12.2739 15.6169 11.9986L12.5 6.13149Z",
    fill: "#F7945E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSuite);
export default __webpack_public_path__ + "static/media/room-suite.50174109f9dce8bf90fd08d685b7f118.svg";
export { ForwardRef as ReactComponent };